import { HarddiskPlusIcon } from './HarddiskPlusIcon';

/**
 * author: Michael Richins
 * id C4EE3559-8772-4A8D-A549-A1A11DEEC830
 * name harddisk-plus
 * version: 4.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/harddisk-plus.svg
 * tags
 */
export const HddPlusIcon = HarddiskPlusIcon;
export default HddPlusIcon